import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValueOf } from 'type-fest';
import { Status } from '~/types';
import { STATUS } from '~/literals';

export interface IPlan {
  name: 'free' | 'pro' | 'infinity';
  price: string;
  business_limit: number;
  client_limit: number;
  has_priority_features: boolean;
  has_priority_support: boolean;
  has_watermark: boolean;
  invoice_limit: number;
}

export interface PlansState {
  plans: IPlan[];
  status: ValueOf<Status>;
}

export const plansState: PlansState = {
  plans: [
    { name: 'free', price: '--', business_limit: -1, client_limit: -1, has_priority_features: false, has_priority_support: false, has_watermark: true, invoice_limit: -1 },
    { name: 'pro', price: '--', business_limit: -1, client_limit: -1, has_priority_features: false, has_priority_support: false, has_watermark: false, invoice_limit: -1 },
    { name: 'infinity', price: '--', business_limit: -1, client_limit: -1, has_priority_features: true, has_priority_support: true, has_watermark: false, invoice_limit: -1 },
  ],
  status: STATUS.IDLE,
};

export const plansSlice = createSlice({
  name: 'plans',
  initialState: plansState,
  reducers: {
    fetchPlans: draft => {
      draft.status = STATUS.RUNNING;
    },
    fetchPlansSuccess: (draft, action: PayloadAction<IPlan[]>) => {
      draft.plans = action.payload;
      draft.status = STATUS.READY;
    },
    fetchPlansFailure: draft => {
      draft.status = STATUS.IDLE;
    },
  },
});

export const { fetchPlans, fetchPlansSuccess, fetchPlansFailure } = plansSlice.actions;

export default plansSlice.reducer;
